<template>
  <div id="app">
    <BestTransport />
  </div>
</template>

<script>
import BestTransport from './views/BestTransport.vue'

export default {
  name: 'App',
  components: {
    BestTransport
  }
}
</script>

<style></style>
